<template>
    <div>
        <buttonlist @help="help" @reflash="reflash" @save="save" ref="SetBtn"></buttonlist>
        <div>
            <table>
                <tr>
                    <td colspan="4">
                        <el-divider content-position="left">{{$t('getapi[3461]')}}</el-divider>
                    </td>
                </tr>
                <tr>
                    <td>                       
                        <el-checkbox v-model="dataDetail.proauto_enabled" true-label='1' false-label='0'></el-checkbox>
                        {{ $t('getapi[13492]') }}
                    </td>                    
                </tr>
            </table>
            <table>
                <tr>                    
                    <!-- <td style="width:50px">{{$t('getapi[13493]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.pur_receivein_defaultlocation"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectScrapPos(1)"></i>
                        </el-input>
                    </td> -->
                    <td style="width:50px">{{$t('getapi[13494]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.prosoreceieve_defaultlocation"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectScrapPos(2)"></i>
                        </el-input>
                    </td>
                </tr>               
            </table>
            <table>
                <tr>
                    <td colspan="4">
                        <el-divider content-position="left">{{$t('getapi[13495]')}}</el-divider>
                    </td>
                </tr>
            </table>
            <table>
                <tr>                    
                    <td style="width:50px">{{$t('getapi[2952]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.proso_createuser"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="soselectperson(1)"></i>
                        </el-input>
                    </td>
                    <td style="width:50px">{{$t('getapi[2788]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.proso_releaseuser"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="soselectperson(2)"></i>
                        </el-input>
                    </td>
                    <td style="width:50px">{{$t('getapi[4908]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.proso_reporteuser"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="soselectperson(3)"></i>
                        </el-input>
                    </td>
                </tr>               
            </table>
            <table>
                <tr>
                    <td colspan="4">
                        <el-divider content-position="left">{{$t('getapi[9332]')}}</el-divider>
                    </td>
                </tr>
            </table>
            <table>
                <tr>                    
                    <td style="width:50px">{{$t('getapi[2952]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.proso_collecissue_createuser"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="faliapcreateperson(1)"></i>
                        </el-input>
                    </td>
                    <td style="width:50px">{{$t('getapi[1864]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.proso_collecissue_keepperson"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="faliapselectperson(2)"></i>
                        </el-input>
                    </td>
                    <td style="width:50px">{{$t('getapi[1747]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.proso_collecissue_registperson"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="faliapselectperson(3)"></i>
                        </el-input>
                    </td>
                </tr>   
                <tr>                    
                    
                    <td style="width:50px">{{$t('getapi[497]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.proso_collecissue_execute"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="faliapcreateperson(4)"></i>
                        </el-input>
                    </td>
                    <td style="width:50px">{{$t('getapi[2180]')}}</td>
                    <td style="width:150px">
                        <el-select  v-model="dataDetail.proso_collecissue_issuedept_code" size="mini"  class="mcolor">
                            <el-option v-for="item in issueDeptType" :key="item.Name" :label="item.Name"
                                        :value="item.Name"></el-option>
                        </el-select>
                    </td>
                </tr>             
            </table>
            <table>
                <tr>
                    <td colspan="4">
                        <el-divider content-position="left">{{$t('getapi[11860]')}}</el-divider>
                    </td>
                </tr>
            </table>
            <table>                
                <tr>                 
                    
                    <td style="width:50px">{{$t('getapi[13496]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.proexeccheck_person"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectcheckperson(1)"></i>
                        </el-input>
                    </td>
                    <td style="width:50px">{{$t('getapi[13497]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.proapplycheck_person"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectcheckperson(2)"></i>
                        </el-input>
                    </td>
                </tr>             
            </table>
            <table>
                <tr>
                    <td colspan="4">
                        <el-divider content-position="left">{{$t('getapi[13498]')}}</el-divider>
                    </td>
                </tr>
            </table>
            <table>                
                <tr>                    
                    <td style="width:50px">{{$t('getapi[2952]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.prosoreceieve_createuser"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectputin(1)"></i>
                        </el-input>
                    </td>
                    <td style="width:50px">{{$t('getapi[1864]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.prosoreceieve_keepperson"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectputin(2)"></i>
                        </el-input>
                    </td>
                    <td style="width:50px">{{$t('getapi[1747]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.prosoreceieve_registperson"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectputin(3)"></i>
                        </el-input>
                    </td>
                </tr>   
                <tr>                    
                    
                    <td style="width:50px">{{$t('getapi[497]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.prosoreceieve_execute"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectputin(4)"></i>
                        </el-input>
                    </td>
                </tr>             
            </table>
            
        </div>
        <!-- <selector :isVisible="false" :isBatch=false :selectType="0" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetProduceSysConfigDataList'" @callback="getDefaultCalendar"
                  ref="defaultcalendar"></selector>
        <selector :isVisible="false" :isBatch=false :selectType="1" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetProduceSysConfigDataList'" @callback="getScrapPos"
                  ref="scrappos"></selector> -->
       
        
       <!-- /// 获取人员信息 
        /// Type 0 采购订单 采购员、1 审批人、2 采购审批模板 采购员、
        /// 3 保管员、记账员、收货员、4 上级人员、
        /// 5 销售订单编辑(销售员)、6 发运人(发货通知) 退货人(采购收货)、7 获取全部人员列表、8 ECN会签人员 9 WI执行人 -->

        <!--发料 保管员 记账员-->
        <selector :isVisible="false" :isBatch=false :selectType="3" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getfaliaoperson" ref="person"></selector><!--保管员 记账员-->
        <selector :isVisible="false" :isBatch=false :selectType="7" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getcreateperson" ref="createperson"></selector><!--保管员 记账员-->
        <!-- <selector :isVisible="false" :isBatch=false :selectType="3" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getperson" ref="person"></selector> -->
        <!-- 获取so工单人员列表 -->
        <selector :isVisible="false" :isBatch=false :selectType="7" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getsoperson" ref="soperson"></selector><!--保管员 记账员-->
        
        <!-- 获取生产入库人员列表 -->
        <selector :isVisible="false" :isBatch=false :selectType="7" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getputinperson" ref="putinperson"></selector><!--保管员 记账员-->
        
        <!-- 获取检验人员列表 -->
        <selector :isVisible="false" :isBatch=false :selectType="7" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getcheckperson" ref="checkperson"></selector><!--保管员 记账员-->
        

         <!-- 默认货位 -->
         <selector :isVisible="cargoVisible" :isBatch=false :selectType="0" :isSplitPage="true"
			:postUrl="'/Basic/Produce/GetProAutoDefCargoPPopupList'" @callback="getcargo" ref="cargo"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'proconfig',
        data() {
            return {
                userData: [], // 用户信息
                dataDetail: {
                    proapplycheck_person:'',//成品报检人,
                    proapplycheck_person_code:'',//成品报检人_code,
                    proauto_enabled:0,//生产自动化是否启用 1 启用 0未启用,
                    proexeccheck_person:'',//成品检验人,
                    proexeccheck_person_code:'',//成品检验人_code,
                    proso_collecissue_createuser:'',//生产发料单_创建人,
                    proso_collecissue_createuser_code:'',//生产发料单_创建人_code,
                    proso_collecissue_execute:'',//生产发料单_执行人,
                    proso_collecissue_execute_code:'',//生产发料单_执行人_code,
                    proso_collecissue_issuedept:'',//生产发料单_领料部门,
                    proso_collecissue_issuedept_code:'',//生产发料单_领料部门_code,
                    proso_collecissue_keepperson:'',//生产发料单_保管员,
                    proso_collecissue_keepperson_code:'',//生产发料单_保管员_code,
                    proso_collecissue_registperson:'',//生产发料单_记账员,
                    proso_collecissue_registperson_code:'',//生产发料单_记账员_code,
                    proso_createuser:'',//SO工单_创建人,
                    proso_createuser_code:'',//SO工单_创建人_code,
                    proso_releaseuser:'',//SO工单_下达人,
                    proso_releaseuser_code:'',//SO工单_下达人_code,
                    proso_reporteuser:'',//SO工单_汇报人,
                    proso_reporteuser_code:'',//SO工单_汇报人_code,
                    prosoreceieve_createuser:'',//成品入库_创建人,
                    prosoreceieve_createuser_code:'',//成品入库_创建人_code,
                    prosoreceieve_defaultlocation:'',//成品入库_默认货位,
                    prosoreceieve_execute:'',//成品入库_执行人,
                    prosoreceieve_execute_code:'',//成品入库_执行人_code,
                    prosoreceieve_keepperson:'',//成品入库_保管员,
                    prosoreceieve_keepperson_code:'',//成品入库_保管员_code,
                    prosoreceieve_registperson:'',//成品入库_记账员,
                    prosoreceieve_registperson_code:'',//成品入库_记账员_code,
                    pur_receivein_defaultlocation:'',//采购入库_默认货位,
                  },
                currencyList: [],
                rateList: [],
                currency_name: '',
                tax_rate: '',
                personType: 1, // 人员类型 1：保管员2：记账员
                issueDeptType: [], // 领料部门数组
                cargoVisible:false,
                cargoType:1,//1 采购入库 默认货位、2 成品入库 默认货位
                sopersontype:1,//SO工单人员类型 1 创建人、2 下达人、3 汇报人
                checkpersontype:1,//检验人员类型 1 成品检验 、2 成品报检人
                putinpersontype:1,//生产入库 1 创建人 、2 保管员、3 记账员、4执行人
            };
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            // that.currencyList = Array.methods.getCurrencyList();
            that.issueDeptType = Array.methods.getIssueDeptWithPFLAG();
            that.getView();
            that.authority();
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1119]"),this.$t("getapi[11]"));
            },
            //权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('save,refresh');
            },
            getView() {
                let that = this;
                let data = '';
                that.$http.urlpost('/Basic/Produce/GetSysProdAutoConfig', data, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            save() {
                let that = this;
                let parm = that.dataDetail;
                that.$http.urlpost('/Basic/Produce/SaveSysProdAutoConfig', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            // selectIssArea() {
            //     let that = this;
            //     that.$refs.issarea.clearInput(true);
            // },
            // getIssArea(data) {
            //     let that = this
            //     console.log(data)
            //     that.dataDetail.Iss_Area = data.shop_position_code
            // },
            faliapcreateperson(val){
                //发料
                let that = this;
                that.personType = val
                that.$refs.createperson.clearInput(true);
            },
            getcreateperson(data){
                //发料创建人
                let that = this
                console.log(data)                 
                if(that.personType == 1){
                    that.dataDetail.proso_collecissue_createuser = data.name
                    that.dataDetail.proso_collecissue_createuser_code = data.code
                } else if(that.personType == 2){
                    that.dataDetail.proso_collecissue_keepperson = data.name
                    that.dataDetail.proso_collecissue_keepperson_code = data.code
                }
                else if(that.personType == 3){
                    that.dataDetail.proso_collecissue_registperson = data.name
                    that.dataDetail.proso_collecissue_registperson_code = data.code
                }
                else if(that.personType == 4){
                    that.dataDetail.proso_collecissue_execute = data.name
                    that.dataDetail.proso_collecissue_execute_code = data.code
                }
                 
            },
            faliapselectperson(val){
                //发料
                let that = this;
                that.personType = val
                that.$refs.person.clearInput(true);
            },
            getfaliaoperson(data){
                //发料
                let that = this
                console.log(data)
                if(that.personType == 1){
                    that.dataDetail.proso_collecissue_createuser = data.name
                    that.dataDetail.proso_collecissue_createuser_code = data.code
                } else if(that.personType == 2){
                    that.dataDetail.proso_collecissue_keepperson = data.name
                    that.dataDetail.proso_collecissue_keepperson_code = data.code
                }
                else if(that.personType == 3){
                    that.dataDetail.proso_collecissue_registperson = data.name
                    that.dataDetail.proso_collecissue_registperson_code = data.code
                }
                else if(that.personType == 4){
                    that.dataDetail.proso_collecissue_execute = data.name
                    that.dataDetail.proso_collecissue_execute_code = data.code
                }
            },
            selectcheckperson(val) {
                //检验
                let that = this;                
                that.checkpersontype=val,
                that.$refs.checkperson.clearInput(true);
            },
            getcheckperson(data){
                //检验
                let that = this;
                if(that.checkpersontype == 1){
                    that.dataDetail.proexeccheck_person = data.name
                    that.dataDetail.proexeccheck_person_code = data.code
                } else if(that.checkpersontype == 2){
                    that.dataDetail.proapplycheck_person = data.name
                    that.dataDetail.proapplycheck_person_code = data.code
                }
            },
            selectputin(val){
                //入库人员
                let that = this;
                that.putinpersontype=val,
                that.$refs.putinperson.clearInput(true);
            },
            
            getputinperson(data){
                //入库人员
                let that = this
                console.log(data)
                if(that.putinpersontype == 1){
                    that.dataDetail.prosoreceieve_createuser = data.name
                    that.dataDetail.prosoreceieve_createuser_code = data.code
                } else if(that.putinpersontype == 2){
                    that.dataDetail.prosoreceieve_keepperson = data.name
                    that.dataDetail.prosoreceieve_keepperson_code = data.code
                }
                else if(that.putinpersontype == 3){
                    that.dataDetail.prosoreceieve_registperson = data.name
                    that.dataDetail.prosoreceieve_registperson_code = data.code
                }
                else if(that.putinpersontype == 4){
                    that.dataDetail.prosoreceieve_execute = data.name
                    that.dataDetail.prosoreceieve_execute_code = data.code
                }
            },
            soselectperson(val){
                //so工单人员
                let that = this;
                that.sopersontype = val
                that.$refs.soperson.clearInput(true);                
            },
            getsoperson(data){
                //so工单人员
                let that = this
                console.log(data)
                if(that.sopersontype == 1){
                    that.dataDetail.proso_createuser = data.name
                    that.dataDetail.proso_createuser_code = data.code
                } else if(that.sopersontype == 2){
                    that.dataDetail.proso_releaseuser = data.name
                    that.dataDetail.proso_releaseuser_code = data.code
                }
                else if(that.sopersontype == 3){
                    that.dataDetail.proso_reporteuser = data.name
                    that.dataDetail.proso_reporteuser_code = data.code
                }
            },
            selectScrapPos(val) {
                let that = this;
                that.cargoVisible = true;
                that.cargoType=val,
                that.$refs.cargo.clearInput(true);
            },
            getcargo(data) {
                let that = this;
                if(that.cargoType==1){
                    console.log(data.cargoposition_code)
                    that.dataDetail.pur_receivein_defaultlocation = data.cargoposition_code;
                }
                else if(that.cargoType==2){
                    console.log(data.cargoposition_code)
                    that.dataDetail.prosoreceieve_defaultlocation = data.cargoposition_code;
                }
            },
            //校验误差控制输入格式
            // checkType(){
            //     let that = this
            //     let match = that.dataDetail.error_control.match(/-?\d+[.]?\d*%?/g);
            //     if(match == null){
            //         that.$message.warning(that.$t('getapi[2979]'))
            //         // that.dataDetail.error_control = ''
            //     }
            // }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
